'use client';

import { Component, type ReactNode } from 'react';

/**
 * Keeps the server-rendered snapshot on screen if the explorer chunk fails to
 * load. Without this, a stale-deploy ChunkLoadError in an old tab throws past
 * React.lazy into the app-level error page and takes the whole (already
 * readable) case study with it.
 */
export class ExplorerBoundary extends Component<
  { fallback: ReactNode; children: ReactNode },
  { failed: boolean }
> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  render() {
    return this.state.failed ? this.props.fallback : this.props.children;
  }
}
